import React, { useState, useEffect, useRef } from "react";
import "../../common/index.scss";
import { connect } from "react-redux";
import SimpleReactValidator from "simple-react-validator";
import {
  actProfile,
  actProfileEdit,
  getUserProfileData,
} from "../../../actions";
import classes from "./profile.module.scss";

const Profile = (props) => {
  const [Data, setData] = useState({
    first_name: "",
    last_name: "",
    address: "",
    city: "",
    state: "",
    country: "india",
    phone: "",
    email: "",
    pincode: "",
    user_id: "",
    ship_address: "",
    ship_city: "",
    ship_state: "",
    ship_pincode: "",
  });

  const validator = useRef(new SimpleReactValidator({ autoForceUpdate: this }));
  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);

  const setStateFromInput = (event) => {
    event.persist();
    setData((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  useEffect(() => {
    props.getUserProfileData();
  }, []);

  useEffect(() => {
    if (props.profile_data && props.profile_data.first_name) {
      setData({
        user_id: props.profile_data.user_id,
        first_name: props.profile_data.first_name,
        last_name: props.profile_data.last_name,
        phone: props.profile_data.phone,
        email: props.profile_data.email,
        address: props.profile_data.address,
        city: props.profile_data.city,
        country: "india",
        state: props.profile_data.state,
        pincode: props.profile_data.pincode,
        ship_address: props.profile_data.ship_address,
        ship_city: props.profile_data.ship_city,
        ship_state: props.profile_data.ship_state,
        ship_pincode: props.profile_data.ship_pincode,
      });
    }
  }, [props.profile_data]);

  const sameBillingAddress = (event) => {
    if (event.target.checked) {
      setData({
        ...Data,
        ship_address: Data.address,
        ship_city: Data.city,
        ship_state: Data.state,
        ship_pincode: Data.pincode,
      });
    } else {
      setData({
        ...Data,
        ship_address: "",
        ship_city: "",
        ship_state: "",
        ship_pincode: "",
      });
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validator.current.allValid()) {
      props.actProfileEdit(Data);
    } else {
      validator.current.showMessages();
      forceUpdate();
    }
  };

  if (!props.profile_data || !props.profile_data.first_name) {
    return (
      <div className="height">
        <img
          src={`${process.env.PUBLIC_URL}/assets/images/sunny/loader/loader.gif`}
          alt=""
          className="loader"
        />
      </div>
    );
  }

  return (
    <div className={classes.profile_page}>
      <div className={classes.profile_card}>
        <div className={classes.header}>
          <h1 className={classes.page_title}>Edit Profile</h1>
          <p className={classes.page_subtitle}>
            Manage your personal details, billing and shipping addresses.
          </p>
        </div>

        <form
          className={classes.profile_form}
          onSubmit={handleSubmit}
        >
          <h4 className={classes.section_heading}>
            <span>User Details</span>
          </h4>
          <div className={classes.form_grid}>
            <div className={classes.form_group}>
              <label className={classes.form_label} htmlFor="first_name">
                First Name<span className="required-asterisk">*</span>
              </label>
              <input
                type="text"
                name="first_name"
                id="first_name"
                placeholder="First Name"
                className={classes.form_input}
                value={Data.first_name}
                onChange={setStateFromInput}
              />
              {validator.current.message(
                "first name",
                Data.first_name,
                "required|alpha_space|min:2|max:50",
                {
                  messages: {
                    required: "Enter first name.",
                    alpha_space: "Use letters only.",
                    min: "At least 2 characters required.",
                    max: "Must not exceed 50 characters.",
                  },
                },
              )}
            </div>
            <div className={classes.form_group}>
              <label className={classes.form_label} htmlFor="last_name">
                Last Name<span className="required-asterisk">*</span>
              </label>
              <input
                type="text"
                name="last_name"
                id="last_name"
                placeholder="Last Name"
                className={classes.form_input}
                value={Data.last_name}
                onChange={setStateFromInput}
              />
              {validator.current.message(
                "last name",
                Data.last_name,
                "required|alpha_space|min:1|max:50",
                {
                  messages: {
                    required: "Enter last name.",
                    alpha_space: "Use letters only.",
                    min: "At least 1 character required.",
                    max: "Must not exceed 50 characters.",
                  },
                },
              )}
            </div>
            <div className={classes.form_group}>
              <label className={classes.form_label} htmlFor="phone">
                Phone Number<span className="required-asterisk">*</span>
              </label>
              <input
                type="tel"
                name="phone"
                id="phone"
                placeholder="Phone Number"
                className={classes.form_input}
                value={Data.phone}
                onChange={setStateFromInput}
              />
              {validator.current.message(
                "phone",
                Data.phone,
                "required|phone|min:10|max:10",
                {
                  messages: {
                    required: "Enter phone number.",
                    phone: "Enter a valid phone number.",
                    min: "Enter a 10-digit phone number.",
                    max: "Enter a 10-digit phone number.",
                  },
                },
              )}
            </div>
            <div className={classes.form_group}>
              <label className={classes.form_label} htmlFor="email">
                Email Address<span className="required-asterisk">*</span>
              </label>
              <input
                type="email"
                name="email"
                id="email"
                placeholder="Email Address"
                className={classes.form_input}
                value={Data.email}
                onChange={setStateFromInput}
              />
              {validator.current.message(
                "email",
                Data.email,
                "required|email",
                {
                  messages: {
                    required: "Enter email address.",
                    email: "Enter a valid email address.",
                  },
                },
              )}
            </div>
          </div>

          <div className={classes.section_block}>
            <h4 className={classes.section_heading}>
              <span>Billing Address</span>
            </h4>
            <div className={classes.form_grid}>
              <div className={`${classes.form_group} ${classes.full_width}`}>
                <label className={classes.form_label} htmlFor="address">
                  Address
                </label>
                <input
                  type="text"
                  name="address"
                  id="address"
                  placeholder="Address"
                  className={classes.form_input}
                  value={Data.address}
                  onChange={setStateFromInput}
                />
              </div>
              <div className={classes.form_group}>
                <label className={classes.form_label} htmlFor="city">
                  Town/City<span className="required-asterisk">*</span>
                </label>
                <input
                  type="text"
                  name="city"
                  id="city"
                  placeholder="City"
                  className={classes.form_input}
                  value={Data.city}
                  onChange={setStateFromInput}
                />
                {validator.current.message(
                  "city",
                  Data.city,
                  "required|alpha_space|min:3|max:125",
                  {
                    messages: {
                      required: "Enter town/city.",
                      alpha_space: "Use letters only.",
                      min: "Enter at least 3 characters.",
                      max: "Use 125 characters or fewer.",
                    },
                  },
                )}
              </div>
              <div className={classes.form_group}>
                <label className={classes.form_label} htmlFor="state">
                  State<span className="required-asterisk">*</span>
                </label>
                <input
                  type="text"
                  name="state"
                  id="state"
                  placeholder="State"
                  className={classes.form_input}
                  value={Data.state}
                  onChange={setStateFromInput}
                />
                {validator.current.message(
                  "state",
                  Data.state,
                  "required|alpha_space|min:3|max:125",
                  {
                    messages: {
                      required: "Enter state.",
                      alpha_space: "Use letters only.",
                      min: "Enter at least 3 characters.",
                      max: "Use 125 characters or fewer.",
                    },
                  },
                )}
              </div>
              <div className={classes.form_group}>
                <label className={classes.form_label} htmlFor="pincode">
                  Pin Code<span className="required-asterisk">*</span>
                </label>
                <input
                  type="text"
                  name="pincode"
                  id="pincode"
                  placeholder="Pin Code"
                  className={classes.form_input}
                  value={Data.pincode}
                  onChange={setStateFromInput}
                />
                {validator.current.message(
                  "pincode",
                  Data.pincode,
                  "required|min:6|max:6",
                  {
                    messages: {
                      required: "Enter pin code.",
                      min: "Enter a 6-digit pin code.",
                      max: "Enter a 6-digit pin code.",
                    },
                  },
                )}
              </div>
              <div className={classes.form_group}>
                <label className={classes.form_label} htmlFor="country">
                  Country<span className="required-asterisk">*</span>
                </label>
                <select
                  name="country"
                  id="country"
                  className={classes.form_select}
                  value={Data.country}
                  onChange={setStateFromInput}
                >
                  <option>India</option>
                </select>
                {validator.current.message(
                  "country",
                  Data.country,
                  "required",
                  { messages: { required: "Select country." } },
                )}
              </div>
            </div>
          </div>

          <div className={classes.section_block}>
            <h4 className={classes.section_heading}>
              <span>Shipping Address</span>
            </h4>
            <label
              className={classes.same_as_billing}
              htmlFor="flexCheckDefault"
            >
              <input
                className={classes.checkbox}
                type="checkbox"
                id="flexCheckDefault"
                onChange={sameBillingAddress}
              />
              <span className={classes.same_as_billing_text}>
                Same as billing address
              </span>
            </label>
            <div className={classes.form_grid}>
              <div className={`${classes.form_group} ${classes.full_width}`}>
                <label className={classes.form_label} htmlFor="ship_address">
                  Address
                </label>
                <input
                  type="text"
                  name="ship_address"
                  id="ship_address"
                  placeholder="Address"
                  className={classes.form_input}
                  value={Data.ship_address}
                  onChange={setStateFromInput}
                />
              </div>
              <div className={classes.form_group}>
                <label className={classes.form_label} htmlFor="ship_city">
                  Town/City<span className="required-asterisk">*</span>
                </label>
                <input
                  type="text"
                  name="ship_city"
                  id="ship_city"
                  placeholder="Town/City"
                  className={classes.form_input}
                  value={Data.ship_city}
                  onChange={setStateFromInput}
                />
                {validator.current.message(
                  "city",
                  Data.ship_city,
                  "required|alpha_space|min:3|max:125",
                  {
                    messages: {
                      required: "Enter town/city.",
                      alpha_space: "Use letters only.",
                      min: "Enter at least 3 characters.",
                      max: "Use 125 characters or fewer.",
                    },
                  },
                )}
              </div>
              <div className={classes.form_group}>
                <label className={classes.form_label} htmlFor="ship_state">
                  State<span className="required-asterisk">*</span>
                </label>
                <input
                  type="text"
                  name="ship_state"
                  id="ship_state"
                  placeholder="State"
                  className={classes.form_input}
                  value={Data.ship_state}
                  onChange={setStateFromInput}
                />
                {validator.current.message(
                  "state",
                  Data.ship_state,
                  "required|alpha_space|min:3|max:125",
                  {
                    messages: {
                      required: "Enter state.",
                      alpha_space: "Use letters only.",
                      min: "Enter at least 3 characters.",
                      max: "Use 125 characters or fewer.",
                    },
                  },
                )}
              </div>
              <div className={classes.form_group}>
                <label className={classes.form_label} htmlFor="ship_pincode">
                  Pin Code<span className="required-asterisk">*</span>
                </label>
                <input
                  type="text"
                  name="ship_pincode"
                  id="ship_pincode"
                  placeholder="Pin Code"
                  className={classes.form_input}
                  value={Data.ship_pincode}
                  onChange={setStateFromInput}
                />
                {validator.current.message(
                  "pincode",
                  Data.ship_pincode,
                  "required|min:6|max:6",
                  {
                    messages: {
                      required: "Enter pin code.",
                      min: "Enter a 6-digit pin code.",
                      max: "Enter a 6-digit pin code.",
                    },
                  },
                )}
              </div>
              <div className={classes.form_group}>
                <label className={classes.form_label} htmlFor="ship_country">
                  Country<span className="required-asterisk">*</span>
                </label>
                <select
                  name="country"
                  id="ship_country"
                  className={classes.form_select}
                  value={Data.country}
                  onChange={setStateFromInput}
                >
                  <option>India</option>
                </select>
                {validator.current.message(
                  "country",
                  Data.country,
                  "required",
                  { messages: { required: "Select country." } },
                )}
              </div>
            </div>
          </div>

          <div className={classes.form_actions}>
            <button
              type="submit"
              className={`${classes.update_btn} uk-button uk-button-primary`}
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  profile_data: state.data.profile_data,
});

export default connect(mapStateToProps, {
  actProfile,
  actProfileEdit,
  getUserProfileData,
})(Profile);
